import type { BlogPosting, Person, WithContext } from 'schema-dts';
import type { BlogPost } from 'types/cms/blog/BlogPost';
import type { Contributor } from 'types/cms/blog/Contributors';
import { getPageUrl } from 'utils/getBaseUrl';

import { articleId, orgId } from './helpers/ids';

interface BuildArticleInput {
  post: BlogPost;
  pagePath: string;
  heroImageUrl: string;
}

const buildAuthor = (contributor: Contributor): Person => ({
  '@type': 'Person',
  name: contributor.contributor.name,
});

export const buildArticle = ({
  post,
  pagePath,
  heroImageUrl,
}: BuildArticleInput): WithContext<BlogPosting> => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  '@id': articleId(pagePath),
  mainEntityOfPage: { '@type': 'WebPage', '@id': getPageUrl(pagePath) },
  headline: post.title,
  description: post.summary,
  image: [heroImageUrl],
  datePublished: post.publishedAt,
  dateModified: post.updatedAt ?? post.publishedAt,
  author:
    post.contributors && post.contributors.length > 0
      ? post.contributors.map(buildAuthor)
      : [{ '@type': 'Organization', '@id': orgId() }],
  publisher: { '@id': orgId() },
});
